module.exports = __webpack_public_path__ + "static/media/soils_manuals_1.87ec4fa0.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_manuals_1.png
// module id = 1285
// module chunks = 0